<template>
    <div>
        <form class="ml-2" @submit.prevent="sendSearch">
            <div style="display: flex; align-items: center"></div>
        </form>
        <form method="POST" :action="route">
            <input type="hidden" name="_token" :value="token" />
            <table class="abc-table mx-auto text-center" style="width: 100%">
                <thead class="abc-title-table">
                    <tr
                        style="border-bottom: 3px solid #1e1e1e; font-size: 12px !important"
                    >
                        <th
                            class="py-3"
                            style="width: 14%; vertical-align: middle; color: #1e1e1e"
                        >
                            <div>{{ __("traductionview.categorie") }}</div>
                            <input
                                class="form-control-4 mb-2 mt-2"
                                style="font-size: 11px; width: auto; text-transform: capitalize"
                                placeholder="Search..."
                                list="list_category"
                                @input="e => handleCategory(e.target.value)"
                            />
                            <datalist id="list_category">
                                <option
                                    v-for="client_category in cats"
                                    :key="client_category.id"
                                >
                                    <span
                                        v-if="
                                            arrBusName.includes(
                                                client_category.name.toLowerCase()
                                            )
                                        "
                                    >
                                        {{
                                            __(
                                                `traductionview.${client_category.name.toLowerCase()}`
                                            )
                                        }}
                                    </span>
                                </option>
                            </datalist>
                        </th>
                        <th
                            style="width: 14%; vertical-align: middle; color: #1e1e1e"
                        >
                            <div>{{ __("traductionview.benif") }}</div>
                            <input
                                class="form-control-4 mb-2 mt-2"
                                style="font-size: 11px; width: auto; text-transform: capitalize"
                                placeholder="Search..."
                                list="list_benef"
                                @input="e => handleBenef(e.target.value)"
                            />
                        </th>
                        <th
                            style="width: 14%; vertical-align: middle; color: #1e1e1e"
                        >
                            <div>{{ __("traductionview.benifline") }}</div>
                            <input
                                class="form-control-4 mb-2 mt-2"
                                style="font-size: 11px; width: auto; text-transform: capitalize"
                                placeholder="Search..."
                                list="list_bus"
                                @input="e => handleBus(e.target.value)"
                            />
                            <datalist id="list_bus">
                                <option
                                    v-for="business_line in bus"
                                    :key="business_line.id"
                                ></option>
                            </datalist>
                        </th>
                        <th
                            style="width: 14%; vertical-align: middle; color: #1e1e1e"
                        >
                            <div>{{ __("traductionview.service") }}</div>
                            <input
                                class="form-control-4 mb-2 mt-2"
                                style="font-size: 11px; width: auto; text-transform: capitalize"
                                placeholder="Search..."
                                list="list_service"
                                @input="e => handleService(e.target.value)"
                            />
                            <datalist id="list_service">
                                <option
                                    v-for="service in filteredServices(
                                        projs[this.searchLine]
                                    )"
                                    :key="service.id"
                                >
                                    {{ service.name_french }}
                                </option>
                            </datalist>
                        </th>
                        <th
                            style="
                width: 14%;
                vertical-align: middle;
                color: #1e1e1e;
                padding-bottom: 45px;
              "
                        >
                            {{ __("traductionview.duration") }}
                        </th>
                        <th
                            style="
                width: 14%;
                vertical-align: middle;
                color: #1e1e1e;
                padding-bottom: 45px;
              "
                        >
                            {{ __("traductionview.delivery") }}
                        </th>
                        <th style="width: 2%; vertical-align: middle"></th>
                    </tr>
                </thead>
                <tbody
                    class="text-center"
                    style="
            font-size: 11px;
            max-height: 600px;
            overflow: auto;
            display: block;
          "
                >
                    <tr
                        v-for="(project, index) in projs"
                        :key="index"
                        :style="
                            searchLine === index
                                ? 'border-bottom: 1px solid rgba(30, 30, 30, 0.1);cursor: pointer; background: #3a9af347'
                                : 'border-bottom: 1px solid rgba(30, 30, 30, 0.1);cursor: pointer;'
                        "
                        @click="selectLine(index)"
                    >
                        <input
                            type="hidden"
                            :name="'form[' + index + '][id]'"
                            :value="project.id"
                        />
                        <input
                            type="hidden"
                            :name="'form[' + index + '][country]'"
                            :value="country.id"
                        />
                        <td
                            class="py-3 px-2"
                            style="'vertical-align: middle; width: 14%;'"
                        >
                            <select
                                class="form-control-4"
                                style="font-size: 11px; width: 100%; text-transform: capitalize"
                                v-model="project.client_category"
                            >
                                <option value="null" disabled>
                                    {{ __("traductionview.selectcategorie") }}
                                </option>
                                <option
                                    v-for="client_category in cats"
                                    :key="client_category.id"
                                    :value="client_category"
                                >
                                    <span
                                        v-if="
                                            arrBusName.includes(
                                                client_category.name.toLowerCase()
                                            )
                                        "
                                    >
                                        {{
                                            __(
                                                `traductionview.${client_category.name.toLowerCase()}`
                                            )
                                        }}
                                    </span>
                                </option>
                            </select>
                            <input
                                v-if="project.client_category != null"
                                type="hidden"
                                :name="
                                    'form[' + index + '][client_category_id]'
                                "
                                :value="project.client_category.id"
                            />
                        </td>
                        <td
                            v-if="
                                project.client_category
                                    ? project.client_category.id == 1
                                    : false
                            "
                            class="px-2"
                            :style="
                                searchCol === 2 && searchLine === index
                                    ? 'vertical-align: middle; width: 14%; border: 2px solid #3A9AF3;'
                                    : 'vertical-align: middle; width: 14%'
                            "
                        >
                            <select
                                class="form-control-4"
                                style="font-size: 11px; width: 100%; text-transform: capitalize"
                                v-model="project.customer"
                                :disabled="project.client_category.id == 2"
                            >
                                <option value="null" disabled>
                                    {{ __("traductionview.selectname") }}
                                </option>
                                <option
                                    v-for="customer in filteredCustomers(
                                        project.client_category
                                    )"
                                    :key="customer.id"
                                    :value="customer"
                                >
                                    {{ customer.firstname }}
                                    {{ customer.lastname }}
                                </option>
                            </select>

                            <input
                                type="hidden"
                                v-if="project.customer != null"
                                style="font-size: 11px"
                                :name="'form[' + index + '][customer_id]'"
                                :value="project.customer.id"
                            />
                        </td>
                        <td
                            v-else
                            class="px-2"
                            style="vertical-align: middle; width: 14%"
                        >
                            N/A
                        </td>
                        <td
                            class="px-2"
                            :style="
                                searchCol === 3 && searchLine === index
                                    ? 'vertical-align: middle; width: 14%; border: 2px solid #3A9AF3;'
                                    : 'vertical-align: middle; width: 14%'
                            "
                        >
                            <select
                                class="form-control-4"
                                style="font-size: 11px; width: 100%; text-transform: capitalize"
                                v-model="project.business_line"
                            >
                                <option value="null" disabled>
                                    {{ __("traductionview.selectline") }}
                                </option>
                                <option
                                    v-for="business_line in bus"
                                    :key="business_line.id"
                                    :value="business_line"
                                >
                                    <span v-if="$lang().locale == 'fr' && business_line.name_french">
                                        {{
                                            business_line.name_french.toLowerCase()
                                        }}
                                    </span>
                                    <span v-else>
                                        {{
                                            business_line.name.toLowerCase()
                                        }}
                                    </span>
                                </option>
                            </select>

                            <input
                                type="hidden"
                                v-if="project.business_line != null"
                                style="font-size: 11px; text-transform: capitalize"
                                :name="'form[' + index + '][business_line_id]'"
                                :value="project.business_line.id"
                            />
                        </td>

                        <td
                            class="px-2"
                            :style="
                                searchCol === 4 && searchLine === index
                                    ? 'vertical-align: middle; width: 14%; border: 2px solid #3A9AF3;'
                                    : 'vertical-align: middle; width: 14%'
                            "
                        >
                            <select
                                class="form-control-4"
                                style="font-size: 11px; width: 100%; text-transform: capitalize"
                                v-model="project.service"
                                @change="onServiceChange(project)"
                            >
                                <option value="null" disabled>
                                    {{ __("traductionview.selectservice") }}
                                </option>
                                <option
                                    v-for="service in filteredServices(project)"
                                    :key="service.id"
                                    :value="service"
                                >
                                    <span v-if="service.name_french">{{
                                        service.name_french
                                    }}</span>
                                    <span v-else>{{ service.name }}</span>
                                </option>
                            </select>

                            <input
                                type="hidden"
                                v-if="project.service != null"
                                style="font-size: 11px; text-transform: capitalize"
                                :name="'form[' + index + '][service_id]'"
                                :value="project.service.id"
                            />
                        </td>
                        <td style="vertical-align: middle; width: 14%">
                            <input
                                v-if="project.service != null"
                                :style="{
                                    visibility:
                                        project.service.service_frequency
                                            .frequency_name != 'unique'
                                            ? 'visible'
                                            : 'collapse'
                                }"
                                :min="1"
                                type="number"
                                class="form-control-4"
                                style="width: 25%; text-align: center; padding: 5px"
                                v-model="project.duration"
                                @change="onDurationChange(project)"
                            />
                            <span v-if="project.service != null">
                                {{
                                    project.service.service_frequency
                                        .frequency_name != "unique"
                                        ? project.service.service_frequency
                                              .frequency_name
                                        : ""
                                }}</span
                            >
                            <input
                                v-if="project.service != null"
                                type="hidden"
                                style="font-size: 11px; width: 100%"
                                :name="'form[' + index + '][frequency]'"
                                :value="project.duration"
                            />
                            <input
                                v-if="project.service != null"
                                type="hidden"
                                style="font-size: 11px"
                                :name="'form[' + index + '][frequency_name]'"
                                :value="
                                    project.service.service_frequency
                                        .frequency_name
                                "
                            />
                        </td>
                        <td style="vertical-align: middle; width: 14%">
                            <span v-if="project.service != null"
                                >{{ project.service.days }}
                                {{ __("traductionview.days") }}
                            </span>
                        </td>
                        <td style="vertical-align: middle; width: 2%">
                            <button
                                style="
                                    font-size: 32px !important;
                                    text-align: center;
                                    vertical-align: middle;
                                    color: red;
                                "
                                v-if="!project.disabled"
                                type="button"
                                class="close"
                                aria-label="Close"
                                v-on:click="removeRow(project)"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div
                class="row justify-content-center"
                style="padding-bottom: 20px"
            >
                <div class="col-md-6 px-4 my-3">
                    <div class="mr-auto" style="width: max-content">
                        <button
                            id="add-project-btn"
                            type="button"
                            class="btn-abc"
                            style="padding: 10px"
                            v-on:click="addRow"
                        >
                            <svg
                                width="1em"
                                height="1em"
                                viewBox="0 0 16 16"
                                class="bi bi-plus-circle mr-2"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                                />
                                <path
                                    fill-rule="evenodd"
                                    d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                                />
                            </svg>
                            {{ __("traductionview.addservice") }}
                        </button>
                        <a
                            v-if="country.id == 115"
                            class="btn-abc"
                            style="padding: 11px"
                            href="/ressources/PDFs/ABC_EXPAT_LOS_KE_2022.pdf"
                            download
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-download mr-2"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"
                                />
                                <path
                                    d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                                />
                            </svg>

                            {{ __("traductionview.downloadourpricelist") }}
                        </a>
                    </div>
                </div>
                <div class="col-md-6 px-4 my-3">
                    <div class="ml-auto" style="width: max-content">
                        <button
                            type="submit"
                            class="btn-abc-green triggerspinner"
                            style="padding: 10px; font-weight: 700 !important"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                fill="currentColor"
                                class="bi bi-check-circle mr-2"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                                />
                                <path
                                    d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                                />
                            </svg>
                            {{ __("traductionview.requestquotationn") }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: [
        "services",
        "countries",
        "business_lines",
        "office",
        "country",
        "client_categories",
        "customers",
        "token",
        "route"
    ],
    data() {
        return {
            form: [],
            servs: [],
            cats: [],
            customs: [],
            counts: [],
            bus: [],
            projs: [],
            servsv: [],
            busizz: [],
            clientcat: [],
            searchLine: 0,
            maxProjs: 10,

            arrBusName: [
                "business",
                "immigration",
                "registration",
                "expansion",
                "marketing",
                "offices",
                "relocation",
                "individual",
                "company"
            ]
        };
    },

    mounted() {
        Object.values(this.customers).forEach(customer => {
            this.customs.push(customer);
        });

        this.client_categories.forEach(client_category => {
            this.cats.push(client_category);
        });

        this.cats = this.cats.sort();

        this.services.forEach(service => {
            this.servs.push(service);
            if (
                !this.bus.find(
                    element => element.id == service.business_line.id
                )
            ) {
                this.bus.push(service.business_line);
            }
        });

        this.counts.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });

        this.bus.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });

        if (this.office == 1) {
            this.addRow();
        } else {
            if (this.office == "virtual_office") {
                this.projs.push({
                    id: null,
                    customer: this.customs[0],
                    client_category: this.cats.find(
                        element => element.name == "Individual"
                    ),
                    //country: this.counts[0],
                    business_line: this.bus.find(
                        element => element.name == "Bizwiz Africa"
                    ),
                    service: this.servs.find(
                        element => element.name == "Virtual office"
                    ),
                    duration: 1,
                    price: 0
                });
            }
            if (this.office == "day_pass") {
                this.projs.push({
                    id: null,
                    customer: this.customs[0],
                    client_category: this.cats.find(
                        element => element.name == "Individual"
                    ),
                    //country: this.counts[0],
                    business_line: this.bus.find(
                        element => element.name == "Bizwiz Africa"
                    ),
                    service: this.servs.find(
                        element => element.name == "Day Pass"
                    ),
                    duration: 1,
                    price: 0
                });
            }
            if (this.office == "flexi_desk") {
                this.projs.push({
                    id: null,
                    customer: this.customs[0],
                    client_category: this.cats.find(
                        element => element.name == "Individual"
                    ),
                    //country: this.counts[0],
                    business_line: this.bus.find(
                        element => element.name == "Bizwiz Africa"
                    ),
                    service: this.servs.find(
                        element => element.name == "Flexi Desk"
                    ),
                    duration: 1,
                    price: 0
                });
            }
            if (this.office == "fixed_desk") {
                this.projs.push({
                    id: null,
                    customer: this.customs[0],
                    client_category: this.cats.find(
                        element => element.name == "Individual"
                    ),
                    //country: this.counts[0],
                    business_line: this.bus.find(
                        element => element.name == "Bizwiz Africa"
                    ),
                    service: this.servs.find(
                        element => element.name == "Fixed Desk"
                    ),
                    duration: 1,
                    price: 0
                });
            }
            if (this.office == "private_office") {
                this.projs.push({
                    id: null,
                    customer: this.customs[0],
                    client_category: this.cats.find(
                        element => element.name == "Company"
                    ),
                    country: this.counts[0],
                    business_line: this.bus.find(
                        element => element.name == "Bizwiz Africa"
                    ),
                    service: this.servs.find(
                        element => element.name == "Private office 5 person"
                    ),
                    duration: 1,
                    price: 0
                });
            }
        }
    },

    computed: {
        total() {
            var tot = 0;
            this.projs.forEach(project => {
                tot += project.price;
            });
            return tot;
        }
    },
    methods: {
        selectLine(i) {
            this.searchLine = i;
        },

        handleCategory(e) {
            let res = e.toLowerCase();
            let te = this.cats.find(x => x.name.toLowerCase().includes(res));
            if (te) {
                this.projs[this.searchLine].client_category = te;
            }
        },
        handleBenef(e) {
            let res = e.toLowerCase();
            let te = this.filteredCustomers(
                this.projs[this.searchLine].client_category
            ).find(x => x.firstname.toLowerCase().includes(res));
            if (te) {
                this.projs[this.searchLine].customer = te;
            }
        },
        handleBus(e) {
            let res = e.toLowerCase();
            let te = this.bus.find(x => x.name.toLowerCase().includes(res));
            if (te) {
                this.projs[this.searchLine].business_line = te;
            }
        },

        handleService(e) {
            let res = e.toLowerCase();
            let te = this.filteredServices(
                this.projs[this.searchLine]
            ).find(x => x.name.toLowerCase().includes(res));
            if (te) {
                this.projs[this.searchLine].service = te;
            }
        },

        filteredServices(project) {
            if (project) {
                if (
                    project.business_line != null &&
                    project.client_category != null
                ) {
                    return this.servs
                        .filter(
                            s =>
                                s.business_line.name ===
                                project.business_line.name
                        )
                        .filter(
                            s =>
                                s.client_category.name ===
                                project.client_category.name
                        );
                } else {
                    return [];
                }
            }
        },

        filteredCustomers(client_category) {
            var pro = 0;
            if (client_category.name == "corporate") {
                return [];
            } else {
                return this.customs;
            }
        },
        onServiceChange(project) {
            if (project.service.service_frequency.frequency_name == "unique") {
                project.duration = 1;
            }
            project.price = project.duration * project.service.price;
        },

        onDurationChange(project) {
            project.price = project.duration * project.service.price;
        },

        addRow() {
            this.searchCol = 1;
            this.searchInput = "";
            this.searchLine = this.projs.length;
            this.projs.push({
                id: null,
                client_category: null,
                customer: null,
                business_line: null,
                service: null,
                duration: 1,
                price: 0
            });
            if(this.projs.length >= this.maxProjs)
            {
                $('#add-project-btn').prop("disabled", true);
                $('#add-project-btn').removeClass("btn-abc");
                $('#add-project-btn').addClass("btn-abc-disabled");
            }
        },

        removeRow(project) {
            this.projs.splice(this.projs.indexOf(project), 1)
            if(this.projs.length < this.maxProjs)
            {
                $('#add-project-btn').prop("disabled", false);
                $('#add-project-btn').removeClass("btn-abc-disabled");
                $('#add-project-btn').addClass("btn-abc");
            }
        }
    }
};
</script>
